import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import * as firebase from 'firebase/app';

import { IStaffUser, IRecruiterUser, IUser, IUserProfileImage, IBankDetails } from '../../interfaces/users';

@Injectable()
export class AuthProvider {
  storageRef: any = firebase.storage().ref();

  constructor(public afAuth: AngularFireAuth, private db: AngularFirestore) {}

  getFbUser(): Promise<any> {
    let user: any;
    return this.afAuth.user
      .map(fbUser => {
        user = fbUser;
        return user;
      })
      .first()
      .toPromise();
  }

  userExists(uid: string) {
    return this.db.doc(`users/${uid}`).ref.get();
  }

  createStaffUser(user: IStaffUser) {
    const userRef = this.db.doc(`users/${user.uid}`);
    userRef.set(user);
    return userRef.update({
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      accountNotifications: true,
      trainingNotifications: true
    });
  }

  createRecruiterUser(user: IRecruiterUser) {
    const userRef = this.db.doc(`users/${user.uid}`);
    userRef.set(user);
    return userRef.update({
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      accountNotifications: true,
      trainingNotifications: true
    });
  }

  getUserByUid(uid: string): Observable<IUser> {
    const userRef = this.db.doc<IUser>(`users/${uid}`);
    return userRef.valueChanges();
  }

  getUserBankDetails(uid: string): Observable<IBankDetails> {
    const userRef = this.db.doc<IBankDetails>(`bankDetails/${uid}`);
    return userRef.valueChanges();
  }

  getRecruiterUser(uid: string): Observable<IRecruiterUser> {
    const userRef = this.db.doc<IRecruiterUser>(`users/${uid}`);
    return userRef.valueChanges();
  }

  updateUserProfileImage(user: IUserProfileImage) {
    const userRef = this.db.doc(`users/${user.uid}`);
    return userRef.update(user);
  }

  updateUserBankDetails(uid: string, bankDetails: IBankDetails) {
    const userRef = this.db.doc(`bankDetails/${uid}`);
    return userRef.set(bankDetails);
  }

  updateUserOneSignal(uid: string, oSId: string) {
    const userRef = this.db.doc(`users/${uid}`);
    return userRef.update({
      oSId: oSId
    });
  }

  updateStaffUser(user: IStaffUser) {
    const userRef = this.db.doc(`users/${user.uid}`);
    userRef.update(user);
    return userRef.update({
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }

  updateSatffUserProvince(uid: string, province: string) {
    const userRef = this.db.doc(`users/${uid}`);
    return userRef.update({
      province: province
    });
  }

  updateRecruiterUser(user: IRecruiterUser) {
    const userRef = this.db.doc(`users/${user.uid}`);
    userRef.update(user);
    return userRef.update({
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }

  updateAccountNotifications(uid: string, enabled: boolean) {
    const userRef = this.db.doc(`users/${uid}`);
    return userRef.update({
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      accountNotifications: enabled
    });
  }

  updateTrainingNotifications(uid: string, enabled: boolean) {
    const userRef = this.db.doc(`users/${uid}`);
    return userRef.update({
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      trainingNotifications: enabled
    });
  }

  logout() {
    this.afAuth.auth.signOut().then(() => {
      location.reload();
    });
    // TODO: add clear cache plus the method
  }

  // Utilities
  dataURItoBlob(dataURI) {
    let array, binary, i;
    binary = atob(dataURI.split(',')[1]);
    array = [];
    i = 0;
    while (i < binary.length) {
      array.push(binary.charCodeAt(i));
      i++;
    }
    return new Blob([new Uint8Array(array)], {
      type: 'image/jpeg'
    });
  }

  dashedCaseString(input: string): string {
    const dashedCase = input.toLowerCase().replace(/ /g, '-').replace(/&/, 'and');
    return dashedCase;
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts